export default __webpack_public_path__ + "static/media/BrandonGrotesque-Bold.870c0c41.woff";